export default {"src":"/_next/static/media/quotes.9499ac82.svg","height":50,"width":56,"blurWidth":0,"blurHeight":0};